<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { websocketConnected, selectedGame, showSample } from './stores';
  import { fade } from 'svelte/transition';
  import { connectionTestPassed } from '../stores/connectionTest';

  const dispatch = createEventDispatcher();

  let games = [];

  // Notify parent frame once if the connection test fails
  let failedNotified = false;
  $: if ($connectionTestPassed === false && !failedNotified) {
    try {
      // Send a simple message the parent can listen for
      window.parent?.postMessage('connectTestFailed', '*');
    } catch {}
    failedNotified = true;
  }

  const getGames = async () => {
    let result = await fetch(
      'https://zz6kknnu3n77kr7ibvzrqiynym0swvvy.lambda-url.af-south-1.on.aws/'
    );
    return result.json();
  };

  const gameSelect = (game): any => {
    $selectedGame = game;
  };

  let showToken = true;
  const spendToken = (): any => {
    // audio needs to be triggered in the same event loop as a user interaction
    showToken = false;
    try {
      (document.getElementById('audioCtl') as HTMLAudioElement).play();
    } catch (error) {
      console.log('error playing source');
      showToken = true;
    }
    setTimeout(() => {
      // showToken = true;
      launch();
    }, 600);
  };

  const launch = (): any => {
    dispatch('message', {
      event: 'connect',
    });
  };

  getGames().then((result) => {
    games = result;
  });

  // Dropdowns
  let selected;
</script>

{#if !$showSample}
  <div class="wrapper">
    <div class="selector">
      <!-- Launch Button -->
      {#if $selectedGame !== null && $selectedGame !== undefined}
        <!-- Token Animation -->
        <div class="token-wrapper" transition:fade>
          <svg
            width="64"
            height="64"
            id="tokenImg"
            class={showToken ? 'bounce' : 'spend'}
          >
            <image
              xlink:href="icons/token.svg"
              src="icons/token.png"
              width="64"
              height="64"
            />
          </svg>
        </div>

        {#if $websocketConnected && showToken && $connectionTestPassed === true}
          <div
            class="launch-button"
            id="launch-button"
            on:click={() => spendToken()}
          >
            <span>INSERT TOKEN</span>
          </div>
        {:else}
          <div class="launch-button">
            <span>
              {#if $connectionTestPassed === null}
                Testing connection
              {:else if $connectionTestPassed === false}
                Connection test failed
              {:else}
                Connecting
              {/if}
            </span>
          </div>
        {/if}
      {:else}
        <div class="launch-button disabled"><span>LOAD GAME</span></div>
      {/if}

      <!-- Fallback Game Selector -->
      {#if $selectedGame === null}
        <select
          bind:value={selected}
          on:change={() => gameSelect(selected)}
          class="dropdown"
        >
          <option value="" disabled selected>Select Game</option>
          {#each games as game}
            <option value={game}>
              {game.name}
            </option>
          {/each}
        </select>
      {/if}
    </div>
  </div>
{/if}

<style>
  .bounce {
    animation-name: token-enter;
    animation-fill-mode: both;
    animation-duration: 0.9s;
  }

  .disabled {
    opacity: 0.5;
  }
  .dropdown {
    position: fixed;
    width: 200px;
    bottom: 0;
    margin: 0 auto 50px -100px;
    padding: 0;
    /* border:1px solid green; */
  }
  .launch-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffc107;
    color: #000;
    border-radius: 20px;
    font-size: medium;
    font-weight: bold;
    height: 2.5rem;
    width: auto;
    padding: 0 20px;
    transition: all 0.2s;
  }
  .launch-button:active {
    background-color: #fff !important;
  }

  .spend {
    animation-name: token-exit;
    animation-fill-mode: both;
    animation-duration: 0.5s;
  }

  .selector {
    /* border:1px solid blue; */
    touch-action: none;
    padding: 10px;
  }

  .token-wrapper {
    position: fixed;
    width: 100%;
    height: 220px;
    left: 0;
    top: 50%;
    margin-top: -110px;
    z-index: -1;
  }
  .token-wrapper svg {
    left: 0;
    vertical-align: bottom;
    /* border: 1px solid blue; */
  }

  .wrapper {
    /* border:1px solid red; */
    touch-action: none;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.95);
    z-index: 1000;
  }

  @keyframes token-enter {
    0% {
      opacity: 0;
      transform: translateY(-1000px) rotate(15deg);
    }
    60% {
      opacity: 1;
      transform: translateY(30px) rotate(15deg);
    }
    80% {
      transform: translateY(-10px) rotate(-0deg);
    }
    100% {
      transform: translateY(0) rotate(-15deg);
    }
  }

  @keyframes token-exit {
    0% {
      opacity: 1;
      transform: translateY(0) rotate(-15deg);
    }
    40% {
      opacity: 1;
      transform: translateY(-75px) rotate(35deg);
    }
    60% {
      opacity: 1;
      transform: translateY(-50px) rotate(35deg);
    }
    100% {
      opacity: 0;
      transform: translateY(80px) rotate(275deg);
    }
  }
</style>
